/* Wishlist Jubylee — stockage navigateur, sans app externe.

   La variante selectionnee est enregistree avec son libelle complet,
   taille et coloris : le bloc titre depose la liste des variantes en
   JSON, et on y retrouve celle dont l'identifiant est actif au moment
   du clic. Le lien enregistre pointe sur ?variant=..., si bien qu'un
   retour depuis la page favoris rouvre la fiche sur le bon choix. */

(function () {
  var KEY = 'jubylee:wishlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
    refreshCounters(list);
    document.dispatchEvent(new CustomEvent('jubylee:wishlist:change', { detail: { items: list } }));
  }

  function refreshCounters(list) {
    var items = list || read();
    var nodes = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = items.length;
      nodes[i].hidden = items.length === 0;
    }
  }

  function contains(list, productId) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].productId) === String(productId)) return true;
    }
    return false;
  }

  function track(eventName, item) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, {
        ProductName: item.title,
        ProductID: item.productId,
        VariantID: item.variantId,
        VariantName: item.variantTitle,
        URL: item.url,
        ImageURL: item.image,
        Price: (parseInt(item.price, 10) || 0) / 100
      }]);
    } catch (e) {}
  }

  function WishlistButton() {
    return Reflect.construct(HTMLElement, [], WishlistButton);
  }
  WishlistButton.prototype = Object.create(HTMLElement.prototype);
  WishlistButton.prototype.constructor = WishlistButton;
  Object.setPrototypeOf(WishlistButton, HTMLElement);

  WishlistButton.prototype.connectedCallback = function () {
    var self = this;
    this.button = this.querySelector('button');
    if (!this.button) return;

    var donnees = this.querySelector('[data-jbl-variants]');
    this.variantes = [];
    if (donnees) {
      try {
        this.variantes = JSON.parse(donnees.textContent) || [];
      } catch (e) {
        this.variantes = [];
      }
    }

    this.button.addEventListener('click', function () { self.toggle(); });

    var info = this.closest('product-info');
    if (info) {
      info.addEventListener('change', function () {
        window.setTimeout(function () { self.syncVariant(); }, 0);
      });
    }

    this.syncVariant();
    this.render();
  };

  WishlistButton.prototype.syncVariant = function () {
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) this.dataset.variantId = input.value;
  };

  WishlistButton.prototype.varianteActive = function () {
    var id = String(this.dataset.variantId || '');
    for (var i = 0; i < this.variantes.length; i++) {
      if (String(this.variantes[i].id) === id) return this.variantes[i];
    }
    return null;
  };

  WishlistButton.prototype.item = function () {
    var v = this.varianteActive();
    var base = this.dataset.url || '';
    var id = this.dataset.variantId;

    return {
      productId: this.dataset.productId,
      variantId: id,
      variantTitle: v && v.title ? v.title : '',
      title: this.dataset.title,
      url: id ? base + '?variant=' + id : base,
      image: v && v.image ? v.image : this.dataset.image,
      price: v ? v.price : (parseInt(this.dataset.price, 10) || 0),
      priceFormatted: v && v.priceFormatted ? v.priceFormatted : (this.dataset.priceFormatted || ''),
      addedAt: Date.now()
    };
  };

  WishlistButton.prototype.toggle = function () {
    var item = this.item();
    var list = read();

    if (contains(list, item.productId)) {
      var kept = [];
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].productId) !== String(item.productId)) kept.push(list[i]);
      }
      write(kept);
    } else {
      list.unshift(item);
      write(list);
      track('Ajout aux favoris', item);
    }

    this.render();
  };

  WishlistButton.prototype.render = function () {
    var active = contains(read(), this.dataset.productId);
    var label = active ? this.dataset.labelOn : this.dataset.labelOff;
    this.classList.toggle('is-active', active);
    this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
    this.button.setAttribute('aria-label', label);
    this.button.setAttribute('title', label);
  };

  if (!window.customElements.get('wishlist-button')) {
    window.customElements.define('wishlist-button', WishlistButton);
  }

  window.JubyleeWishlist = { read: read, write: write, refresh: refreshCounters };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refreshCounters(); });
  } else {
    refreshCounters();
  }
})();
